import { TopBannerMessage } from '@post-office/browser--jira-pulsar/common/components/top-banner-message';

import { createRender, type HydrationResult } from './types';

import { type JSX } from 'react/jsx-runtime';

export const render: (renderProps: Omit<HydrationResult, 'postOffice'>) => JSX.Element | null =
	createRender(() => <TopBannerMessage />);

export default render;
